import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export interface GetFreightStatisticQueryResult {
  freightPercentageOverTime: FreightPercentageOverTime[];
  freightPercentageAllTime: freightPercentageAllTime;
  worstPdvs: WorstPdvs[];
  pdvDeliveryTimes: PdvDeliveryTime[];
  deliveryTotals: DeliveryTotals;
  distributorAndWaitingTime: DistributorAndWaitingTime[];
  freightsAwaitingDriver: freightsAwaitingDriver[];
}

export interface freightsAwaitingDriver {
  freight_freightId: string;
  freight_createdAt: string;
  minutesDiff: string;
  loadNumbers: string;
  distributorName: string;
}

export interface TimeSpan {
  seconds: number;
  milliseconds: number;
}

export interface FreightPercentageOverTime {
  date: string;
  averagePercentageDaily: number;
}

export interface freightPercentageAllTime {
  averagePercentage: number;
  averageFreightDaily: number;
  freightCount: string;
}

export interface DeliveryTotals {
  FreightAverageAcceptTime: number;
  AWAITING_DRIVER_ASSIGNMENT: string;
  READY_FOR_PICKUP: string;
  COMPLETED: string;
  PROBLEM_REPORTED: string;
}

export interface DistributorAndWaitingTime {
  distributor: string;
  waitingTime: number;
  totalWeight: number;
}

export interface FreightPercentageOverTime {
  date: string;
  freightCount: string;
  averagePercentageDaily: number;
}

export interface WorstPdvs {
  corporateName: string;
  waitingTime: number | null;
  cancelledCount: string;
}

export interface PdvDeliveryTime {
  minDeliveryTime: number | null;
  maxDeliveryTime: number | null;
  avgDeliveryTime: number | null;
  corporateName: string;
}

export default function useGetFreightStatistics() {
  const [loading, setLoading] = useState(false);

  async function execute(): Promise<
    GetFreightStatisticQueryResult | undefined
  > {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/freights/statistics');

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
